<nav class="navbar navbar-dark">
  <a class="navbar-brand" [routerLink]="'/info'">Chiro Sint-Jozef Bloemendaal</a>
</nav>